module.exports = __webpack_public_path__ + "img/Vector.164f956f.svg";